export default __webpack_public_path__ + "static/kenneth-rohde-christiansen-0e377c7d7dc5e66f5f43b91b86afb25e.jpg";